<p-dialog
  header="Email Preview - Confirm Sending"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '750px', maxHeight: '90vh' }"
  [closable]="true"
  (onHide)="onHide()"
  [draggable]="false"
  [resizable]="false"
>
  <div class="email-preview-content">
    <div class="email-summary">
      <i class="fa fa-envelope"></i>
      <span>
        Sending <strong>{{ withEmailCount }}</strong> email(s) to drivers.
        <ng-container *ngIf="withoutEmailCount > 0">
          <br />
          <span class="text-warning">
            <i class="fa fa-exclamation-triangle"></i>
            {{ withoutEmailCount }} trip(s) have no driver email and will be skipped.
          </span>
        </ng-container>
      </span>
    </div>

    <div class="email-list">
      <div
        *ngFor="let email of emails; let i = index"
        class="email-item"
        [class.no-email]="!email.hasEmail"
      >
        <div class="email-header" (click)="toggleExpand(email)">
          <div class="email-header-row">
            <i
              class="pi"
              [class.pi-chevron-down]="email.expanded"
              [class.pi-chevron-right]="!email.expanded"
            ></i>
            <span class="email-index">#{{ i + 1 }}</span>
            <span class="email-recipient" [title]="email.driverName">
              <i class="fa fa-user"></i> {{ email.driverName }}
            </span>
            <span *ngIf="!email.hasEmail" class="badge badge-warning skip-badge">Skipped</span>
          </div>
          <div class="email-header-row email-header-subrow">
            <span class="email-to" [title]="email.to">
              <i class="fa fa-envelope-o"></i>
              {{ email.hasEmail ? email.to : "No email address" }}
            </span>
            <span class="email-subject-truncated" [title]="email.subject">
              {{ email.subject }}
            </span>
          </div>
        </div>
        <div class="email-body" *ngIf="email.expanded && email.hasEmail">
          <div class="email-field">
            <label>To:</label>
            <span>{{ email.to }}</span>
          </div>
          <div class="email-field" *ngIf="email.cc">
            <label>CC:</label>
            <span>{{ email.cc }}</span>
          </div>
          <div class="email-field">
            <label>Subject:</label>
            <span>{{ email.subject }}</span>
          </div>
          <div class="email-field email-body-field">
            <label>Body:</label>
            <div class="email-body-content" [innerHTML]="email.body"></div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="emails.length === 0" class="empty-state">No emails to preview.</div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancel"
      icon="pi pi-times"
      class="p-button-secondary"
      (click)="close()"
    ></button>
    <button
      pButton
      type="button"
      label="Send Emails"
      icon="pi pi-send"
      class="btn btn-primary"
      [disabled]="withEmailCount === 0 || !emailFeaturesEnabled"
      (click)="onConfirm()"
    ></button>
  </ng-template>
</p-dialog>
